module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Open Space Technology")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "titlepage"
  }, [_c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("OPEN SPACE "), _c('br'), _vm._v("TECHNOLOGY ")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("A User’s Guide "), _c('br'), _c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Third Edition")])]), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("HARRISON OWEN ")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "9781576757758_WEB_0004_001",
      "src": "images/9781576757758_WEB_0004_001.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "pageiii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7170636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitlePage.vue
// module id = 63
// module chunks = 0